(function () {
  'use strict';

  function initDrawerNavigation() {
    var container = document.getElementById('drawer-panels');
    if (!container) return;

    var backBtn = document.getElementById('drawer-back-btn');
    var backTitle = document.getElementById('drawer-panel-title');
    var triggers = container.querySelectorAll('[data-trigger-submenu]');
    var submenus = container.querySelectorAll('.drawer-submenu-list');

    // Handle Open Sub-menu
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var targetId = trigger.getAttribute('data-trigger-submenu');
        var parentTitle = trigger.getAttribute('data-parent-title') || 'BACK';

        // Hide all submenus first
        submenus.forEach(function (menu) {
          menu.style.display = 'none';
        });

        // Show target submenu
        var targetMenu = document.getElementById(targetId);
        if (targetMenu) {
          targetMenu.style.display = 'block';
        }

        // Update header back button text (with uppercase title)
        if (backTitle) {
          backTitle.textContent = parentTitle.toUpperCase();
        }

        // Slide to Panel 2
        container.setAttribute('data-panel', '2');
      });
    });

    // Handle Back Button click
    if (backBtn) {
      backBtn.addEventListener('click', function () {
        // Slide back to Panel 1
        container.setAttribute('data-panel', '1');
      });
    }

    // Optional: Reset back to Panel 1 when drawer is closed (e.g. listen on nav-close or close overlay)
    var navClose = document.getElementById('nav-close');
    var overlay = document.querySelector('.mobile-nav__overlay');
    
    function resetPanel() {
      setTimeout(function () {
        container.setAttribute('data-panel', '1');
      }, 350);
    }

    if (navClose) {
      navClose.addEventListener('click', resetPanel);
    }
    if (overlay) {
      overlay.addEventListener('click', resetPanel);
    }
  }

  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawerNavigation);
  } else {
    initDrawerNavigation();
  }
})();
